const REGION: string | undefined = process.env.REACT_APP_REGION;
  const IDENTIFY_POOL_ID: string | undefined =process.env.REACT_APP_IDENTITY_POOL_ID;
  const USER_POOL_ID: string | undefined = process.env.REACT_APP_USER_POOL_ID;
  const CLIENT_ID: string | undefined = process.env.REACT_APP_CLIENT_ID;
  const signinuri : string | undefined = `${window.location.origin}/dashboard`;
  const signouturi : string | undefined = `${window.location.origin}/login`;
  const COGNITO_URL: string | undefined = process.env.REACT_APP_COGNITO_URL;
  const BACKEND_URL_LOCAL : string | undefined = process.env.REACT_APP_BACKEND_URL;
  const NODE_API_URL: string | undefined = process.env.REACT_APP_NODE_API_URL;
const APP_ENV: string = (process.env.REACT_APP_ENVIRONMENT || "").toLowerCase().trim();
const DEV_NODE_API_URL = "https://dev-hasura.quickasyst.com";
const STAGING_NODE_API_URL = "https://staging-hasura.quickasyst.com";
const QA_NODE_API_URL = "https://qa-hasura.quickasyst.com";
const PROD_NODE_API_URL = "https://admin-hasura.quickasyst.com";
const NODE_API_FALLBACK =
  APP_ENV === "staging"
    ? STAGING_NODE_API_URL
    : APP_ENV === "qa"
      ? QA_NODE_API_URL
      : APP_ENV === "prod" || APP_ENV === "production"
        ? PROD_NODE_API_URL
        : DEV_NODE_API_URL;
  export const config = {
    backend_url: BACKEND_URL_LOCAL ?? "",
    node_api_url: String(NODE_API_URL || NODE_API_FALLBACK),

    amplifyConfig: {
      aws_project_region: REGION,
      aws_cognito_identity_pool_id: IDENTIFY_POOL_ID,
      aws_cognito_region: REGION,
      aws_user_pools_id: USER_POOL_ID,
      aws_user_pools_web_client_id: CLIENT_ID,
      federationTarget: 'COGNITO_USER_POOLS', 
      oauth: {
        domain: COGNITO_URL,
        redirectSignIn: signinuri,
        redirectSignOut: signouturi,
        responseType: "code",
      },
    },
  }; 
   